import { useDataDrivenSegmentsAllotted, useRefetchSegmentQuota } from '@/services/db/environment/segment-limit';
import { useAddonPurchase } from './use-addon-purchase';

/**
 * Opens the segments add-on purchase, and refetches the segment quota once it
 * is bought so an at-cap state clears.
 */
export function useOpenSegmentsAddon(): () => Promise<void> {
  const { openAddon } = useAddonPurchase();
  const includedCount = useDataDrivenSegmentsAllotted();
  const refetchSegmentQuota = useRefetchSegmentQuota();

  return async () => {
    if (includedCount == null) return;
    const purchase = await openAddon({ request: { key: 'segments', includedCount } });
    if (purchase?.isPurchased === true) await refetchSegmentQuota();
  };
}
